// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import tz from "dayjs/plugin/timezone";

// dayjs.extend(utc);
// dayjs.extend(tz);

// import { Frequency, Options, RRule, Weekday } from "rrule";

// /**
//  * RRule wrapper to correctly handle timezone
//  * - store everything in utc
//  * - getters will return time in initialized timezone
//  * - setter for timezone
//  *
//  *
//  * // tests!
//  * hour shift is handled
//  * min shift is handled
//  * day shift is handled
//  * year shift is handled
//  */
// export class WRRule {
//   tzOffset: number;
//   public opts: Options;
//   constructor(options: { timeZones?: string; rrule: RRule }) {
//     this.tzOffset = dayjs().tz(options.timeZones).utcOffset();
//     this.opts = {
//       freq: Frequency.MONTHLY,
//       dtstart: null,
//       interval: 0,
//       wkst: null,
//       count: null,
//       until: null,
//       tzid: null,
//       bysetpos: null,
//       bymonth: null,
//       bymonthday: null,
//       bynmonthday: null,
//       byyearday: null,
//       byweekno: null,
//       byweekday: null,
//       bynweekday: null,
//       byhour: null,
//       byminute: null,
//       bysecond: null,
//       byeaster: null,
//     };
//     console.log(options);
//     // todso
//   }

//   setTimeZone(timeZone: string) {
//     this.tzOffset = dayjs().tz(timeZone).utcOffset();
//   }

//   getUpcomingEvents() {}

//   toString() {
//     return "";
//   }

//   /**
//    * mirror options that are in RRule constructor
//    */
//   set_dtstart(startDate: string | number | Date | null) {
//     if (!startDate) {
//       return null;
//     }
//     return typeof startDate === "object" ? startDate : new Date(startDate);
//   }
//   set_wkst(wkst: Weekday | null) {
//     /**
//      * @todo convert Weekday selection to utc weekday
//      */
//   }
//   set_until(until: Date | null) {
//     this.opts.until = until;
//   }

//   // handle bysetpos later (really complex)
//   // set_bysetpos(bysetpos: number | number[] | null){
//   //     if(!bysetpos){
//   //         this.opts.bysetpos = null;
//   //     }
//   //     const _bysetpos = Array.isArray(bysetpos) ? bysetpos : [bysetpos];
//   // }

//   /**
//    * no tz change for bymonth
//    */
//   set_bymonth(bymonth: number | number[] | null) {
//     return bymonth;
//   }
//   set_bymonthday(bymonthday: number | number[] | null, tzOffset?: number) {
//     if (!bymonthday) {
//       return null;
//     }
//     const _bymonthday = Array.isArray(bymonthday) ? bymonthday : [bymonthday];
//     const dtStartHour = dayjs(this.opts.dtstart).tz("UTC").hour();
//     const dayShift = dtStartHour - ((this.tzOffset - (tzOffset ?? 0)) % 24);
//     /**
//      * @todo handle variable month days
//      */
//     return _bymonthday.map((dayNumber) => pymod(dayNumber - dayShift, 31));
//   }

//   /**
//    * Shift monthday for tz calculation
//    *
//    * @param bynmonthday
//    * @param tzOffset
//    */
//   set_bynmonthday(bynmonthday: number[] | null, tzOffset?: number) {
//     if (!bynmonthday) {
//       return null;
//     }
//     const _bynmonthday = Array.isArray(bynmonthday)
//       ? bynmonthday
//       : [bynmonthday];
//     const dtStartHour = dayjs(this.opts.dtstart).tz("UTC").hour();
//     const dayShift = dtStartHour - ((this.tzOffset - (tzOffset ?? 0)) % 24);
//     /**
//      * @todo handle variable month days
//      */
//     return _bynmonthday.map((dayNumber) => pymod(dayNumber - dayShift, 31));
//   }

//   /**
//    * Change year day if the timezone date needs it
//    *
//    * @param byyearday
//    * @param tzOffset
//    */
//   set_byyearday(byyearday: number | number[] | null, tzOffset?: number) {
//     if (!byyearday) {
//       return null;
//     }

//     const _byyearday = Array.isArray(byyearday) ? byyearday : [byyearday];
//     const dtStartHour = dayjs(this.opts.dtstart).tz("UTC").hour();
//     const dayShift = dtStartHour - ((this.tzOffset - (tzOffset ?? 0)) % 24);
//     /**
//      * @todo handle leap year
//      */
//     return _byyearday.map((dayNumber) => pymod(dayNumber - dayShift, 365));
//   }

//   /**
//    * I Don't think this needs to be changed
//    */
//   set_byweekno(byweekno: number | number[] | null, tzOffset?: number) {
//     if (!byweekno) {
//       return null;
//     }
//     const _byweekno = Array.isArray(byweekno) ? byweekno : [byweekno];
//     return _byweekno;
//     // // change from sunday 0 day to monday 0 day
//     // const dtStartHour = dayjs(this.opts.dtstart).tz("UTC").hour()
//     // const dayShift = dtStartHour - (this.tzOffset - (tzOffset ?? 0)) % 24
//     // _byweekno.map(dayNumber => {
//     //     /**
//     //      * @todo handle leap year
//     //      */
//     //     return pymod(dayNumber - dayShift, 365)
//     // })
//   }

//   /**
//    * It will return the UTC versions of the Weekdays
//    *
//    * @param byweekday the weekday of the current users timezone or of the tz thats passed in
//    * @param tzOffset the tzoffset of the weekdays being passed in
//    */
//   set_byweekday(
//     byweekday: Weekday | Weekday[] | null,
//     tzOffset?: number,
//   ): null | Weekday[] {
//     if (!byweekday) {
//       return null;
//     }

//     const _byweekday = Array.isArray(byweekday) ? byweekday : [byweekday];
//     const dtStartHour = dayjs(this.opts.dtstart).tz("UTC").hour();
//     return _byweekday.map((weekday) => {
//       const dayShift = dtStartHour - ((this.tzOffset - (tzOffset ?? 0)) % 24);
//       return new Weekday(pymod(weekday.weekday + dayShift, 7));
//     });
//   }

//   /**
//    * It will return the weekday number but in UTC time
//    *
//    * @param bynweekday
//    * @param tzOffset
//    */
//   set_bynweekday(
//     bynweekday: number | number[] | null,
//     tzOffset?: number,
//   ): number[] | null {
//     if (!bynweekday) {
//       return null;
//     }
//     const _bynweekday = Array.isArray(bynweekday) ? bynweekday : [bynweekday];
//     const dtStartHour = dayjs(this.opts.dtstart).tz("UTC").hour();
//     return _bynweekday.map((weekday) => {
//       const dayShift = dtStartHour - ((this.tzOffset - (tzOffset ?? 0)) % 24);
//       return pymod(weekday - dayShift, 6);
//     });
//   }

//   /**
//    * It will return the "hours" of this in utc
//    *
//    * @param byhours local hour number on the 24 houre clock or for the tzOffset time thats been passed in.
//    * @param tzOffset timezone offset for this byHours
//    */
//   set_byhour(byhour: number | number[] | null, tzOffset?: number) {
//     if (!byhour) {
//       return null;
//     }
//     const _byhour = Array.isArray(byhour) ? byhour : [byhour];
//     /**
//      * convert hour if timezone rollover.
//      * - If the hour roles over to the next timezone then we will have to also shift the day too
//      * @todo test rollover and the effect on the day
//      */
//     return _byhour.map((hour) => hour - (this.tzOffset - (tzOffset ?? 0)));
//   }

//   set_byminute(byminute: number | number[] | null) {
//     if (!byminute) {
//       return null;
//     }
//     /**
//      * timezones wont rollover the minutes
//      */
//     return Array.isArray(byminute) ? byminute : [byminute];
//   }
//   set_bysecond(bysecond: number | number[] | null) {
//     if (!bysecond) {
//       return null;
//     }
//     /**
//      * Timezones wont roll over the seconds
//      */
//     return Array.isArray(bysecond) ? bysecond : [bysecond];
//   }
//   set_byeaster(byeaster: number | number[] | null) {
//     if (!byeaster) {
//       return null;
//     }
//     return Array.isArray(byeaster) ? byeaster : [byeaster];
//   }
// }

/**
 * Internal utilities from rrule
 */

/**
 * closure/goog/math/math.js:modulo
 * Copyright 2006 The Closure Library Authors.
 * The % operator in JavaScript returns the remainder of a / b, but differs from
 * some other languages in that the result will have the same sign as the
 * dividend. For example, -1 % 8 == -1, whereas in some other languages
 * (such as Python) the result would be 7. This function emulates the more
 * correct modulo behavior, which is useful for certain applications such as
 * calculating an offset index in a circular list.
 *
 * @param {number} a The dividend.
 * @param {number} b The divisor.
 * @return {number} a % b where the result is between 0 and b (either 0 <= x < b
 * or b < x <= 0, depending on the sign of b).
 */
export const pymod = function (a: number, b: number) {
  const r = a % b;
  // If r and b differ in sign, add b to wrap the result to the correct sign.
  return r * b < 0 ? r + b : r;
};
